import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  CustomerTokenType,
  CustomerTokenContextType,
  CustomerTokenContext,
} from 'contexts/CustomerTokenContext';
import { ReduxState } from 'ducks';

export const useCustomerToken = (): CustomerTokenContextType => {
  const context = React.useContext(CustomerTokenContext);

  const apiSettings = useSelector((state: ReduxState) => state.server.settings.all);

  const now = new Date().getTime();

  const buffer = 1 * 60 * 1000; // 1 minute

  console.log('expiredAt', new Date(context?.expiresAt ?? 0).toLocaleString());
  console.log('now      ', new Date().toLocaleString());

  if (context?.expiresAt !== 0 && (context?.expiresAt ?? 0) < now + buffer) {
    if (context?.idProvider === 'COGNITO' && context?.refreshToken) {
      console.log('refreshToken out');
      const tokenUrl = `https://${
        apiSettings?.customer_ledger_settings?.cognito?.domain ?? ''
      }/oauth2/token`;
      const clientId = apiSettings.customer_ledger_settings?.cognito?.client_id ?? '';
      fetch(tokenUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `grant_type=refresh_token&client_id=${clientId}&refresh_token=${context.refreshToken}`,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('refreshToken data', data);
          const newContext: CustomerTokenType = {
            accessToken: data.access_token,
            idToken: data.id_token,
            refreshToken: context.refreshToken,
            expiresAt: now + data.expires_in * 1000,
            idProvider: context.idProvider,
            apiKey: context.apiKey,
          };
          context.setToken(newContext);
        })
        .catch((error) => {
          console.error(error);
          context.logout();
        });
    }
  }

  return context;
};
